import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=6732532a&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=6732532a&prod&lang=scss&scoped=true"
import style1 from "./Chat.vue?vue&type=style&index=1&id=6732532a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6732532a",
  null
  
)

export default component.exports